module.exports = __webpack_public_path__ + "static/media/tutorial1.4b97dd99.jpg";